import React from "react";
import { Box, Container, Typography } from "@mui/material";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import HandshakeIcon from "@mui/icons-material/Handshake";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";

const processSteps = [
  {
    icon: <AssignmentIndIcon fontSize="inherit" />,
    title: "Request a Service",
    text:
      "Submit your service request for HVAC, Cleaning, Water Restoration, or Roofing. Tell us your issue, location, and preferred schedule.",
  },
  {
    icon: <EventAvailableIcon fontSize="inherit" />,
    title: "Schedule & Inspection",
    text:
      "We confirm your appointment and assess the job—whether it’s HVAC repair, deep cleaning, water damage inspection, or roofing evaluation.",
  },
  {
    icon: <HandshakeIcon fontSize="inherit" />,
    title: "Approve & Hire Us",
    text:
      "Get transparent pricing and scope of work. Once approved, our certified technicians are assigned to your HVAC, cleaning, restoration, or roofing service.",
  },
  {
    icon: <CleaningServicesIcon fontSize="inherit" />,
    title: "Service Completion",
    text:
      "Our experts complete the job using professional tools and industry standards—leaving your space safe, clean, and fully restored.",
  },
];


const ProcessSection = () => {
  return (
    <>
      {/* INLINE CSS */}
      <style>{`
        .process-sec {
          position: relative;
          padding: 120px 0;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          overflow: hidden;
        }

        /* FLOATING SHAPES */
        .shape-mockup {
          position: absolute;
          z-index: 1;
        }

        .process-shape-1 { top: 80px; left: 120px; } 
        .process-shape-2 { top: 100px; right: 180px; }
        .process-shape-3 { bottom: 100px; left: 50px; }
        .process-shape-4 { bottom: 80px; right: 120px; }

        .jump {
          animation: jump 3.5s infinite ease-in-out;
        }

        .jump-reverse {
          animation: jumpReverse 3.5s infinite ease-in-out;
        }

        @keyframes jump {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-18px); }
        }

        @keyframes jumpReverse {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(18px); }
        }

        /* TITLE */
        .title-area { margin-bottom: 60px; }

        .sub-title {
          color: #7ac142;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 2px;
          display: inline-block;
          margin-bottom: 10px;
        }

        .sec-title {
          font-size: 42px;
          font-weight: 800;
          color: #ffffff;
        }

        /* PROCESS GRID */
        .process-grid {
          display: flex;
          gap: 30px;
          flex-wrap: wrap;
          justify-content: center;
          position: relative;
          z-index: 2;
        }

        .process-box {
          background: rgba(255,255,255,0.08);
          border-radius: 20px;
          padding: 42px 32px;
          text-align: center;
          flex: 1 1 260px;
          max-width: 280px;
          backdrop-filter: blur(6px);
          transition: transform .3s ease, box-shadow .3s ease;
        }

        .process-box:hover {
          transform: translateY(-10px);
          box-shadow: 0 30px 60px rgba(0,0,0,.25);
        }

        .box-icon {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: rgba(255,255,255,0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 22px;
          font-size: 34px;
          color: #ffffff;
        }

        .box-title {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 12px;
          color: #ffffff;
        }

        .box-text {
          font-size: 15px;
          line-height: 1.6;
          color: #ffffff;
          opacity: 0.85;
        }

        /* RESPONSIVE */
        @media (max-width: 1200px) {
          .process-shape-2,
          .process-shape-3 {
            display: none;
          }
        }

        @media (max-width: 768px) {
          .sec-title { font-size: 32px; }
          .process-sec { padding: 90px 0; }
           .process-shape-1{
    position: absolute;   
    top: 16px;
    right: 16px;          
    left: auto;           
    bottom: auto;
  }
    .process-shape-4{
    position: absolute;   
    left: 0px;          
   bottom: 0px;
    }
        }
      `}</style>

      {/* SECTION */}
      <Box
        component="section"
        id="process-sec"
        className="process-sec"
        sx={{
          backgroundImage:
            "url('https://html.themehour.net/kleanix/demo/assets/img/bg/team-bg-1.jpg')",
        }}
      >
        {/* SHAPES */}
        <Box className="shape-mockup jump process-shape-1">
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/team-sahpe-1-1.svg"
            alt="shape"
          />
        </Box>

        <Box className="shape-mockup jump process-shape-2">
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/servicce-2-shape-theme2.svg"
            alt="shape"
          />
        </Box>

        <Box className="shape-mockup jump-reverse process-shape-3">
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/servicce-2-shape-theme2.svg"
            alt="shape"
          />
        </Box>

        <Box className="shape-mockup jump-reverse process-shape-4">
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/team-sahpe-1-1.svg"
            alt="shape"
          />
        </Box>

        <Box>
          {/* TITLE */}
          <Box className="process-grid">
          <Box className="title-area" >
            <Typography className="sub-title">
              Work Process
            </Typography>
            <Typography className="sec-title">
              How We Are Working!
            </Typography>
          </Box>
          </Box>

          {/* PROCESS CARDS */}
          <Box className="process-grid">
            {processSteps.map((step) => (
              <Box key={step.title} className="process-box">
                <Box className="box-icon">
                  {step.icon}
                </Box>
                <Typography className="box-title">
                  {step.title}
                </Typography>
                <Typography className="box-text">
                  {step.text}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ProcessSection;
